import type { AqItemType, AqTab, AqTypeMeta } from './types';

export const GROWTH_APPROVALS_META = {
  eyebrow: 'Google Ads & SEO · Approvals',
  titleLead: 'Approval',
  titleAccent: 'queue',
  description:
    'Review and approve what ELVA has prepared for you — campaigns, articles, landing pages, and GBP posts. Each item shows why ELVA decided it and the facts behind the recommendation before you take action.',
} as const;

export const AQ_TABS: readonly AqTab[] = [
  { id: 'all', label: 'All' },
  { id: 'campaign', label: 'Campaigns' },
  { id: 'article', label: 'Articles' },
  { id: 'landing-page', label: 'Landing Pages' },
  { id: 'gbp-post', label: 'GBP Posts' },
  { id: 'review-reply', label: 'Review Replies' },
  { id: 'seo-fix', label: 'SEO Fixes' },
] as const;

export const AQ_TYPE_META: Record<AqItemType, AqTypeMeta> = {
  campaign: { label: 'CAMPAIGN', icon: 'broadcast', tone: 'success', action: 'campaign' },
  article: { label: 'ARTICLE', icon: 'doc', tone: 'info', action: 'article' },
  'landing-page': { label: 'LANDING PAGE', icon: 'globe', tone: 'iris', action: 'landing page' },
  'gbp-post': { label: 'GBP POST', icon: 'image', tone: 'gold', action: 'GBP post' },
  'review-reply': { label: 'REVIEW REPLY', icon: 'chat', tone: 'terra', action: 'review reply' },
  'seo-fix': { label: 'SEO FIX', icon: 'cog', tone: 'gold', action: 'SEO fix' },
};
